module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CloudWarehouseView.js"));
	}, "CloudWarehouseView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CloudWarehouseView!./src/pages/Shop/Member/Personal/CloudWarehouse/CloudWarehouseView.js
// module id = 959
// module chunks = 438